import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

/** Settings → Printeeng (settings/Printeeng::*): profilele de tiparire si alarmele proprii. */
export type PrinteengTab = { id: string; label: string; icon: string; href: string; right: string }
export type PrinteengShell = { pageTitle: string; moduleUrl: string; tabs: PrinteengTab[] }

export const TABS = ['profiles', 'alarms'] as const
export type PrinteengTabId = (typeof TABS)[number]

export function isPrinteengTab(value: string): value is PrinteengTabId {
  return (TABS as readonly string[]).includes(value)
}

export type Company = { ID: number; Nume: string }
export type ProfileRow = {
  ID: number
  name: string
  quota: number
  period: number
  period_type: string
  devices: number
  company_id: number
  DT_RowId: string
}

export function printeengShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'printeeng', 'shell'],
    queryFn: () => apiGet<PrinteengShell>('/settings/printeeng'),
  })
}

export function profilesPageQuery() {
  return queryOptions({
    queryKey: ['settings', 'printeeng', 'profiles'],
    queryFn: () => apiGet<{ companies: Company[]; company: number; moduleUrl: string }>('/settings/printeeng/profiles'),
  })
}

export function profilesTableQuery() {
  return queryOptions({
    queryKey: ['settings', 'printeeng', 'profiles', 'table'],
    queryFn: () => apiGet<{ data: ProfileRow[]; recordsTotal: number }>('/settings/printeeng/profiles/table'),
  })
}

export function profileSettings(id: number) {
  return apiGet<{ profileId: number; profile: Record<string, unknown>; companies: Company[] }>('/settings/printeeng/profiles/' + id)
}

export function createProfile(fields: Record<string, PostValue>) {
  return apiPost<{ ok?: boolean; id?: number }>('/settings/printeeng/profiles', fields)
}

export function updateProfile(fields: Record<string, PostValue>) {
  return apiPost<{ ok?: boolean }>('/settings/printeeng/profiles/update', fields)
}

export function removeProfile(profile: number) {
  return apiPost<{ ok?: boolean }>('/settings/printeeng/profiles/remove', { profile })
}
